(function () {
  function resolveGallery(root) {
    const id = root.getAttribute("data-media-gallery-id");
    const gallery = id ? document.getElementById(id) : null;
    if (gallery) return gallery;
    const product = root.closest(".wt-product");
    if (product) {
      const g = product.querySelector(".wt-product__gallery");
      if (g) return g;
    }
    return null;
  }

  /** Visible viewport (layout coords); prefers Visual Viewport API on mobile. */
  function getViewportClientRect() {
    const vv = window.visualViewport;
    if (vv && typeof vv.width === "number" && vv.width > 0 && typeof vv.height === "number" && vv.height > 0) {
      return {
        left: vv.offsetLeft,
        top: vv.offsetTop,
        width: vv.width,
        height: vv.height,
      };
    }
    return {
      left: 0,
      top: 0,
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  /** Intersection of two axis-aligned rects { left, top, width, height } (same coord space as getBoundingClientRect). */
  function intersectClientRects(a, b) {
    const ar = a.left + a.width;
    const ab = a.top + a.height;
    const br = b.left + b.width;
    const bb = b.top + b.height;
    const left = Math.max(a.left, b.left);
    const top = Math.max(a.top, b.top);
    const right = Math.min(ar, br);
    const bottom = Math.min(ab, bb);
    const w = right - left;
    const h = bottom - top;
    return { left, top, width: Math.max(0, w), height: Math.max(0, h) };
  }

  function wireRoot(root) {
    const dialog = root.querySelector(".brand-shape-dialog");
    if (!dialog) return;
    const openBtn = root.querySelector(".brand-shape-badge__button");
    const shapeWrap = dialog.querySelector(".brand-shape-dialog__shape-wrap");
    const overlay = dialog.querySelector(".brand-shape-dialog__overlay");
    if (!openBtn || !shapeWrap) return;
    const dialogImg = shapeWrap.querySelector(".brand-shape-dialog__img");

    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }

    const sectionId = root.getAttribute("data-am-section-id");
    const sentinel = sectionId ? document.getElementById(`am-pebble-sentinel-${sectionId}`) : null;
    const gallery = resolveGallery(root);
    const dataGalleryEl = gallery ? gallery.querySelector("[data-gallery]") : null;
    let released = false;
    let layoutRaf = null;
    let lastFocused = null;
    let pebbleIsOpen = false;
    let pebbleIsClosing = false;
    let pebbleShieldBound = false;
    let closeTransitionHandler = null;

    function isRightCornerLayout() {
      return window.matchMedia("(max-width: 899px)").matches;
    }

    function badgeInsetPx() {
      return window.matchMedia("(min-width: 900px)").matches ? 24 : 16;
    }

    /** Layout viewport bottom in client Y (stable vs URL bar / visualViewport quirks). */
    function layoutViewportClientBottom() {
      const vv = window.visualViewport;
      if (vv && typeof vv.height === "number" && vv.height > 0) {
        return vv.offsetTop + vv.height;
      }
      return window.innerHeight || document.documentElement.clientHeight;
    }

    function getLastSlideEl() {
      /* Re-query last slide each time — Swiper may add/remove slides */
      const container = dataGalleryEl || gallery;
      if (!container) return null;
      const slides = container.querySelectorAll("[data-swiper-slide]");
      return slides.length ? slides[slides.length - 1] : container;
    }

    /** Swiper carousel (< sliderEnabledBreakpoint): anchor to gallery, not last slide (off-screen). */
    function badgeAnchorEl() {
      const galleryEl = dataGalleryEl || gallery;
      if (!galleryEl) return null;
      const dataGallery = galleryEl.querySelector("[data-gallery]") || galleryEl;
      if (dataGallery.classList.contains("swiper")) {
        return galleryEl;
      }
      return getLastSlideEl() || galleryEl;
    }

    function shouldHideBadgeOnMobile() {
      if (!isRightCornerLayout() || pebbleIsOpen) return false;

      const mainEl = document.querySelector(".wt-product__main");
      if (!mainEl) return false;

      const mainRect = mainEl.getBoundingClientRect();
      const offset = badgeInsetPx();
      const badgeSize = root.offsetHeight || 115;

      if (released) {
        const dg = badgeAnchorEl();
        if (!dg) return false;
        const r = dg.getBoundingClientRect();
        const pebbleBottom = r.bottom - offset;
        const pebbleTop = pebbleBottom - badgeSize;
        if (mainRect.top < pebbleBottom) return true;
        if (pebbleTop < 0) return true;
        return false;
      }

      const pebbleRect = root.getBoundingClientRect();
      return mainRect.top < pebbleRect.bottom;
    }

    function syncBadgeVisibility() {
      const hide = shouldHideBadgeOnMobile();
      root.classList.toggle("brand-shape-root--scroll-hidden", hide);
    }

    function syncBadgePosition() {
      const dg = badgeAnchorEl();
      /* Mobile: always pin to the gallery corner (16px). Viewport CSS bottom/right
         sat below short galleries and looked further than 16px from the image. */
      const pinToGallery = isRightCornerLayout() || released;
      if (!pinToGallery || !dg) {
        clearBadgePosition();
        return;
      }
      const r = dg.getBoundingClientRect();
      const offset = badgeInsetPx();
      const badgeW = root.offsetWidth || 115;
      const badgeH = root.offsetHeight || 115;
      root.style.top = `${r.bottom - badgeH - offset}px`;
      root.style.bottom = "auto";
      if (isRightCornerLayout()) {
        root.style.left = `${r.right - badgeW - offset}px`;
        root.style.right = "auto";
      } else {
        root.style.left = `${r.left + offset}px`;
        root.style.right = "auto";
      }
    }

    function clearBadgePosition() {
      root.style.left = "";
      root.style.bottom = "";
      root.style.top = "";
      root.style.right = "";
    }

    function sentinelWantsReleased() {
      const triggerEl = badgeAnchorEl();
      if (!triggerEl) return false;
      const r = triggerEl.getBoundingClientRect();
      const bottom = layoutViewportClientBottom();
      return r.bottom <= bottom;
    }

    function setReleased(on) {
      if (on === released) return;
      released = on;
      if (on) {
        root.classList.add("brand-shape-root--released");
        syncBadgePosition();
      } else {
        root.classList.remove("brand-shape-root--released");
        clearBadgePosition();
      }
    }

    function updateReleasedFromSentinel() {
      setReleased(sentinelWantsReleased());
    }

    function onScrollOrResize() {
      if (layoutRaf !== null) cancelAnimationFrame(layoutRaf);
      layoutRaf = requestAnimationFrame(() => {
        layoutRaf = null;
        updateReleasedFromSentinel();
        syncBadgePosition();
        /* While closing, chase the moving (scroll-driven) badge so shrink lands on the live corner. */
        if (pebbleIsClosing) {
          computeCloseTransformVars();
        }
        syncBadgeVisibility();
      });
    }

    if (sentinel && gallery && sentinel.parentNode === gallery) {
      window.addEventListener("scroll", onScrollOrResize, { passive: true });
      window.addEventListener("resize", onScrollOrResize);
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", onScrollOrResize);
        window.visualViewport.addEventListener("scroll", onScrollOrResize);
      }
      updateReleasedFromSentinel();
      syncBadgePosition();
      syncBadgeVisibility();
    }

    function isMobilePebbleLayout() {
      return isRightCornerLayout();
    }

    /** True when the gallery no longer intersects the visible viewport. */
    function galleryIsOutOfView(gEl) {
      const g = gEl.getBoundingClientRect();
      const vp = getViewportClientRect();
      const vpBottom = vp.top + vp.height;
      if (g.bottom <= vp.top + 2) return true;
      if (g.top >= vpBottom - 2) return true;
      return false;
    }

    /** Desktop: open shape has scrolled down to (or past) the gallery bottom edge. */
    function shapeReachedGalleryBottom(gEl) {
      const g = gEl.getBoundingClientRect();
      const wrapRect = shapeWrap.getBoundingClientRect();
      if (g.height < 2 || wrapRect.height < 2) return false;
      return wrapRect.bottom >= g.bottom - 0.5;
    }

    function syncDialogToGallery() {
      const gEl = resolveGallery(root);
      if (!gEl) {
        clearDialogLayout();
        return;
      }

      if (pebbleIsOpen) {
        if (!isMobilePebbleLayout() && shapeReachedGalleryBottom(gEl)) {
          closeDialog();
          return;
        }
        if (galleryIsOutOfView(gEl)) {
          closeDialog();
          return;
        }
      }

      /* Mobile/tablet open: full-viewport scrim over header + gallery; shape stays centered on top */
      if (isMobilePebbleLayout() && pebbleIsOpen) {
        const vp = getViewportClientRect();
        dialog.style.position = "fixed";
        dialog.style.left = `${vp.left}px`;
        dialog.style.top = `${vp.top}px`;
        dialog.style.width = `${vp.width}px`;
        dialog.style.height = `${vp.height}px`;
        return;
      }

      const g = gEl.getBoundingClientRect();
      if (g.width < 2 || g.height < 2) {
        clearDialogLayout();
        return;
      }

      const vp = getViewportClientRect();
      const clip = intersectClientRects(g, vp);

      /* Gallery left viewport while open — close instead of full-screen fallback */
      if (clip.width < 2 || clip.height < 2) {
        if (pebbleIsOpen) {
          closeDialog();
          return;
        }
        if (g.width >= 2 && g.height >= 2) {
          dialog.style.position = "fixed";
          dialog.style.left = `${vp.left}px`;
          dialog.style.top = `${vp.top}px`;
          dialog.style.width = `${vp.width}px`;
          dialog.style.height = `${vp.height}px`;
        } else {
          clearDialogLayout();
        }
        return;
      }

      dialog.style.position = "fixed";
      dialog.style.left = `${clip.left}px`;
      dialog.style.top = `${clip.top}px`;
      dialog.style.width = `${clip.width}px`;
      dialog.style.height = `${clip.height}px`;
    }

    function clearDialogLayout() {
      dialog.style.position = "";
      dialog.style.left = "";
      dialog.style.top = "";
      dialog.style.width = "";
      dialog.style.height = "";
    }

    function isDialogVisible() {
      return dialog.classList.contains("is-visible");
    }

    function showDialog() {
      dialog.classList.add("is-visible");
      dialog.removeAttribute("aria-hidden");
    }

    function hideDialog() {
      dialog.classList.remove("is-visible");
      dialog.setAttribute("aria-hidden", "true");
    }

    function onLayout() {
      if (isDialogVisible()) {
        syncDialogToGallery();
      }
    }

    function prepareRootForOpenDialog() {
      if (!isMobilePebbleLayout()) return;
      root.style.top = "";
      root.style.bottom = "";
      root.style.left = "";
      root.style.right = "";
    }

    function setPageShield(on) {
      document.body.classList.toggle("am-pebble-dialog-open", on);
      if (gallery) {
        gallery.inert = on;
      }
      if (dataGalleryEl) {
        dataGalleryEl.inert = on;
      }
    }

    function onPebbleShieldCapture(e) {
      if (!pebbleIsOpen) return;

      let t = e.target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (t && shapeWrap.contains(t)) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") {
        e.stopImmediatePropagation();
      }

      if (e.type === "pointerdown" || e.type === "click") {
        closeDialog();
      }
    }

    function bindPebbleShield() {
      if (pebbleShieldBound) return;
      pebbleShieldBound = true;
      ["pointerdown", "mousedown", "touchstart", "click", "touchend"].forEach((type) => {
        window.addEventListener(type, onPebbleShieldCapture, true);
      });
    }

    function unbindPebbleShield() {
      if (!pebbleShieldBound) return;
      pebbleShieldBound = false;
      ["pointerdown", "mousedown", "touchstart", "click", "touchend"].forEach((type) => {
        window.removeEventListener(type, onPebbleShieldCapture, true);
      });
    }

    function onKeydown(e) {
      if (e.key === "Escape") closeDialog();
    }

    function onDocumentClose(e) {
      if (!pebbleIsOpen) return;
      let t = e.target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (t && shapeWrap.contains(t)) return;
      if (t && dialog.contains(t)) {
        e.preventDefault();
        e.stopPropagation();
        closeDialog();
        return;
      }
      if (t && root.contains(t)) return;
      closeDialog();
    }

    function onOverlayClose(e) {
      if (!pebbleIsOpen) return;
      if (shapeWrap.contains(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") {
        e.stopImmediatePropagation();
      }
      closeDialog();
    }

    function onDialogBackdropClose(e) {
      if (!pebbleIsOpen) return;
      let t = e.target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (!t || shapeWrap.contains(t)) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") {
        e.stopImmediatePropagation();
      }
      closeDialog();
    }

    /* Tap the expanded pebble to dismiss */
    function onShapeWrapClose(e) {
      if (!pebbleIsOpen) return;
      if (e.button != null && e.button !== 0) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") {
        e.stopImmediatePropagation();
      }
      closeDialog();
    }

    function bindDocumentClose() {
      document.addEventListener("click", onDocumentClose, true);
      document.addEventListener("touchend", onDocumentClose, true);
    }

    function unbindDocumentClose() {
      document.removeEventListener("click", onDocumentClose, true);
      document.removeEventListener("touchend", onDocumentClose, true);
    }

    function clearCloseTransformVars() {
      shapeWrap.style.removeProperty("--pebble-corner-x");
      shapeWrap.style.removeProperty("--pebble-corner-y");
      shapeWrap.style.removeProperty("--pebble-corner-z");
      shapeWrap.style.removeProperty("--pebble-corner-scale");
      shapeWrap.style.removeProperty("--pebble-corner-scale-x");
      shapeWrap.style.removeProperty("--pebble-corner-scale-y");
    }

    function detachCloseTransitionListener() {
      if (!closeTransitionHandler) return;
      shapeWrap.removeEventListener("transitionend", closeTransitionHandler);
      closeTransitionHandler = null;
    }

    function clearShapeWrapCloseLayout() {
      shapeWrap.style.removeProperty("padding-block");
      shapeWrap.style.removeProperty("overflow");
      if (dialogImg) {
        dialogImg.style.removeProperty("width");
        dialogImg.style.removeProperty("height");
      }
    }

    function prepareShapeWrapForCloseMeasure() {
      shapeWrap.style.paddingBlock = "0";
      shapeWrap.style.overflow = "hidden";
      if (dialogImg) {
        dialogImg.style.width = "100%";
        dialogImg.style.height = "100%";
      }
      void shapeWrap.offsetWidth;
    }

    function computeCloseTransformVars() {
      /* Use dialog center (not mid-animation shape rect) so vars stay absolute and can retarget while closing. */
      const dialogRect = dialog.getBoundingClientRect();
      const badgeRect = openBtn.getBoundingClientRect();
      const badgeImg = openBtn.querySelector(".brand-shape-badge__img");
      if (
        dialogRect.width < 1 ||
        dialogRect.height < 1 ||
        badgeRect.width < 1 ||
        badgeRect.height < 1 ||
        !badgeImg ||
        !dialogImg ||
        dialogImg.offsetWidth < 1 ||
        dialogImg.offsetHeight < 1 ||
        badgeImg.offsetWidth < 1 ||
        badgeImg.offsetHeight < 1
      ) {
        return false;
      }

      const wrapCenterX = dialogRect.left + dialogRect.width / 2;
      const wrapCenterY = dialogRect.top + dialogRect.height / 2;
      const badgeTargetX = badgeRect.left + badgeRect.width / 2;
      const badgeTargetY = badgeRect.top + badgeRect.height / 2;
      const closeScale = Math.min(
        badgeImg.offsetWidth / dialogImg.offsetWidth,
        badgeImg.offsetHeight / dialogImg.offsetHeight
      );
      const cornerX = badgeTargetX - wrapCenterX;
      const cornerY = badgeTargetY - wrapCenterY;

      shapeWrap.style.setProperty("--pebble-corner-x", `${cornerX}px`);
      shapeWrap.style.setProperty("--pebble-corner-y", `${cornerY}px`);
      shapeWrap.style.setProperty("--pebble-corner-z", "0px");
      shapeWrap.style.setProperty("--pebble-corner-scale", String(closeScale));
      shapeWrap.style.removeProperty("--pebble-corner-scale-x");
      shapeWrap.style.removeProperty("--pebble-corner-scale-y");
      return true;
    }

    function mobileOpenPebbleSize(vp) {
      return {
        width: Math.min(480, vp.width - 48),
        height: Math.min(500, vp.height - 120),
      };
    }

    /** Set closed-state vars so open animation starts at the corner badge (before --dialog-open moves root). */
    function computeOpenTransformVars() {
      const badgeRect = openBtn.getBoundingClientRect();
      if (badgeRect.width < 1 || badgeRect.height < 1) return false;

      const gEl = resolveGallery(root);
      let dialogTarget;
      if (isMobilePebbleLayout()) {
        dialogTarget = getViewportClientRect();
      } else if (gEl) {
        const g = gEl.getBoundingClientRect();
        const vp = getViewportClientRect();
        dialogTarget = intersectClientRects(g, vp);
      } else {
        return false;
      }

      if (dialogTarget.width < 2 || dialogTarget.height < 2) return false;

      const dialogCenterX = dialogTarget.left + dialogTarget.width / 2;
      const dialogCenterY = dialogTarget.top + dialogTarget.height / 2;
      const badgeCenterX = badgeRect.left + badgeRect.width / 2;
      const badgeCenterY = badgeRect.top + badgeRect.height / 2;
      const mobileOpen = isMobilePebbleLayout() ? mobileOpenPebbleSize(dialogTarget) : null;
      const wrapW = mobileOpen ? mobileOpen.width : Math.min(580, dialogTarget.width - 24);
      const wrapH = mobileOpen ? mobileOpen.height : Math.min(620, dialogTarget.height - 24);
      const openScale = Math.min(
        badgeRect.width / wrapW,
        badgeRect.height / Math.max(wrapH, 1)
      );

      shapeWrap.style.setProperty("--pebble-corner-x", `${badgeCenterX - dialogCenterX}px`);
      shapeWrap.style.setProperty("--pebble-corner-y", `${badgeCenterY - dialogCenterY}px`);
      /* Match close: keep motion in the XY plane (no perspective foreshortening). */
      shapeWrap.style.setProperty("--pebble-corner-z", "0px");
      shapeWrap.style.setProperty("--pebble-corner-scale", String(openScale));
      return true;
    }

    function finishCloseDialog() {
      hideDialog();
      shapeWrap.style.visibility = "hidden";

      detachCloseTransitionListener();
      dialog.classList.remove("is-closing");
      root.classList.remove("brand-shape-root--dialog-open", "brand-shape-root--dialog-closing");
      openBtn.style.visibility = "visible";
      clearDialogLayout();
      clearShapeWrapCloseLayout();
      clearCloseTransformVars();
      shapeWrap.style.visibility = "";
      syncBadgePosition();
      syncBadgeVisibility();
      pebbleIsClosing = false;

      if (lastFocused && lastFocused.focus) {
        lastFocused.focus({ preventScroll: true });
      }

      if (!pebbleIsOpen) {
        setPageShield(false);
      }
    }

    function openDialog() {
      if (isDialogVisible() || pebbleIsClosing) return;

      detachCloseTransitionListener();
      clearCloseTransformVars();
      dialog.classList.remove("is-closing", "is-open");

      lastFocused = document.activeElement;
      openBtn.style.visibility = "hidden";

      pebbleIsOpen = true;
      setPageShield(true);
      bindPebbleShield();
      bindDocumentClose();

      /* Position dialog while hidden; measure badge before prepareRoot clears released coords. */
      syncDialogToGallery();
      if (!computeOpenTransformVars()) {
        clearCloseTransformVars();
      }

      prepareRootForOpenDialog();
      root.classList.add("brand-shape-root--dialog-open");
      dialog.classList.add("is-preparing");
      showDialog();
      if (dialog.focus) {
        dialog.focus({ preventScroll: true });
      }

      window.addEventListener("resize", onLayout);
      window.addEventListener("scroll", onLayout, true);
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", onLayout);
        window.visualViewport.addEventListener("scroll", onLayout);
      }

      requestAnimationFrame(() => {
        syncDialogToGallery();
        dialog.classList.remove("is-preparing");
        void shapeWrap.offsetWidth;
        requestAnimationFrame(() => {
          dialog.classList.add("is-open");
        });
      });

      document.addEventListener("keydown", onKeydown);
    }

    function pointerClientXY(e) {
      if (e.changedTouches && e.changedTouches[0]) {
        return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      }
      if (typeof e.clientX === "number" && typeof e.clientY === "number") {
        return { x: e.clientX, y: e.clientY };
      }
      return null;
    }

    function hitOpenButtonRect(x, y) {
      if (x == null || y == null) return false;
      const rect = openBtn.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2) return false;
      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    }

    /**
     * Released: badge is fixed on body but aligned over the gallery; PhotoSwipe <a> can still win hit-testing.
     * If the pointer is over the badge rect but the event target is not the button, open from capture.
     */
    function onGalleryOpenMisclickCapture(e) {
      if (
        pebbleIsOpen ||
        pebbleIsClosing ||
        document.body.classList.contains("am-pebble-dialog-open")
      ) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }
        return;
      }
      if (!released) return;
      if (e.button != null && e.button !== 0) return;
      const xy = pointerClientXY(e);
      if (!xy) return;
      if (!hitOpenButtonRect(xy.x, xy.y)) return;
      let t = e.target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (t && openBtn.contains(t)) return;
      e.preventDefault();
      e.stopPropagation();
      openDialog();
    }

    function closeDialog() {
      if (!pebbleIsOpen || pebbleIsClosing) return;

      pebbleIsOpen = false;
      pebbleIsClosing = true;
      unbindPebbleShield();
      unbindDocumentClose();

      window.removeEventListener("resize", onLayout);
      window.removeEventListener("scroll", onLayout, true);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", onLayout);
        window.visualViewport.removeEventListener("scroll", onLayout);
      }

      document.removeEventListener("keydown", onKeydown);
      detachCloseTransitionListener();

      /* Restore corner badge position before measuring close target. */
      root.classList.remove("brand-shape-root--dialog-open");
      root.classList.add("brand-shape-root--dialog-closing");
      syncBadgePosition();
      prepareShapeWrapForCloseMeasure();

      if (!computeCloseTransformVars()) {
        clearCloseTransformVars();
      }

      void shapeWrap.offsetWidth;

      dialog.classList.add("is-closing");
      dialog.classList.remove("is-open");

      closeTransitionHandler = (e) => {
        if (e.target !== shapeWrap || e.propertyName !== "transform") return;
        finishCloseDialog();
      };
      shapeWrap.addEventListener("transitionend", closeTransitionHandler);
    }

    if (gallery) {
      gallery.addEventListener("click", onGalleryOpenMisclickCapture, true);
    }

    openBtn.addEventListener("click", openDialog);

    dialog.addEventListener("pointerdown", onDialogBackdropClose, true);
    dialog.addEventListener("click", onDialogBackdropClose, true);

    shapeWrap.addEventListener("pointerdown", onShapeWrapClose);
    shapeWrap.addEventListener("click", onShapeWrapClose);

    if (overlay) {
      overlay.addEventListener("pointerdown", onOverlayClose);
      overlay.addEventListener("click", onOverlayClose);
    }
  }

  function init() {
    document.querySelectorAll("[data-brand-shape-root]").forEach(wireRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
